import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Facebook from "../../../svg/facebook.inline.svg"
import Twitter from "../../../svg/twitter.inline.svg"
import Instagram from "../../../svg/instagram.inline.svg"
import Linkedin from "../../../svg/linkedin.inline.svg"
import FooterComponent from "./Footer"
import { mapFooter } from "../../../gatsby/transformers/footerTransformer"

const socialItems = [
  {
    id: "facebook",
    url: "https://www.facebook.com/thesocialsupermarket",
    label: "Facebook",
    Svg: Facebook,
    external: true,
  },
  {
    id: "twitter",
    url: "https://twitter.com/soc_supermarket",
    label: "Twitter",
    Svg: Twitter,
    external: true,
  },
  {
    id: "instagram",
    url: "https://www.instagram.com/thesocialsupermarket",
    label: "Instagram",
    Svg: Instagram,
    external: true,
  },
  {
    id: "linkedin",
    url: "https://www.linkedin.com/company/the-social-supermarket",
    label: "LinkedIn",
    Svg: Linkedin,
    external: true,
  },
]

const FooterWrapper = (): JSX.Element => {
  const data = useStaticQuery(queryString)
  const footerData = mapFooter(data)

  return <FooterComponent footerData={{ ...footerData, socialItems }} />
}

const queryString = graphql`
  {
    infoMenu: allWpMenu(filter: { slug: { eq: "info" } }) {
      nodes {
        menuItems {
          nodes {
            id
            label
            url
          }
        }
      }
    }
    shopMenu: allWpMenu(filter: { slug: { eq: "shop" } }) {
      nodes {
        menuItems {
          nodes {
            id
            label
            url
          }
        }
      }
    }
    allWp {
      nodes {
        options {
          custom {
            featuredBadges {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 300, placeholder: NONE, layout: CONSTRAINED)
                  }
                }
              }
              url {
                url
                title
              }
            }
          }
        }
      }
    }
  }
`

export default FooterWrapper
